import { Accordion, Button, ButtonGroup, Col, Row } from "react-bootstrap";
import ModalDommus from "../../ModalDommus";
import { useState } from "react";
import NovoChamado from "../../FormTickets/NovoChamado";

export default function MinhasSolicitacoes({ eventKey }) {
    let urlGuFront = process.env.REACT_APP_GU_FRONT;
    const [openModal, setOpenModal] = useState(false);

    return (
        <>
            <Accordion.Item eventKey={eventKey}>
                <Accordion.Header>Minhas solicitações:</Accordion.Header>
                <Accordion.Body>
                    <Row>
                        <ButtonGroup>
                            <div
                                onClick={() => setOpenModal(true)}
                                className="btn btn-warning btn-sm"
                            >
                                Abrir Chamado
                            </div>
                            <Button
                                href={urlGuFront + "/tickets"}
                                variant="secondary"
                                size="sm"
                            >
                                Meus Chamados
                            </Button>
                        </ButtonGroup>
                    </Row>
                </Accordion.Body>
            </Accordion.Item>

            <ModalDommus
                open={openModal}
                close={() => setOpenModal(false)}
                titulo="Novo Ticket"
                className="modal-tickets"
            >
                <NovoChamado
                    close={() => setOpenModal(false)}
                    corButton={"#f7941d"}
                    corTop={"#f7941d"}
                />
            </ModalDommus>
        </>
    );
}
